<template>
  <span>
    <div v-if="event && event.revote_majority_id" class="text-center font-weight-bold mt-4">
      Cette résolution n'a pas été adoptée faute de majorité {{ majorityName }}, elle va faire
      l'objet d'un second vote.
    </div>
    <div
      v-else-if="resolution.status == meetingResolutionStatuses.not_resolved"
      class="text-center font-weight-bold mt-4"
    >
      Sans objet - cette résolution n'a pas fait l'objet d'un vote
    </div>
    <div
      v-else-if="resolution.status == meetingResolutionStatuses.sans_vote"
      class="text-center font-weight-bold mt-4"
    >
      Sans objet - cette résolution n'a pas fait l'objet d'un vote
    </div>
    <div
      v-else-if="resolution.status == meetingResolutionStatuses.rejected_lack_of_majority"
      class="text-center font-weight-bold mt-4"
    >
      Cette résolution n'a pas été adoptée faute de majorité : {{ majorityName }}
    </div>
    <div
      v-else-if="resolution.status == meetingResolutionStatuses.not_voted"
      class="text-center font-weight-bold mt-4"
    >
      Cette resolution n'a pas été soumise au vote
    </div>
    <div v-else class="text-center font-weight-bold mt-4">
      Cette résolution a été
      <span v-if="resolution.status == meetingResolutionStatuses.accepted">adoptée</span>
      <span v-if="resolution.status == meetingResolutionStatuses.rejected">rejetée</span> à la
      majorité :
      <span v-if="resolution.revote_majority_id">
        {{ findMajorityData(resolution.revote_majority_id).name }}
      </span>
      <span v-else>{{ findMajorityData(resolution.majority_id).name }}</span>
    </div>
  </span>
</template>
<script>
import { meetingResolutionStatuses } from "@/constants/meeting-resolution.js";

export default {
  props: ["resolution", "event", "majorityName"],
  data() {
    return {
      meetingResolutionStatuses,
    };
  },
};
</script>
